<template>
  <div class="menberApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div v-if="total <= 0" class="vipMember" @click="$router.push('paymenber?id='+id)">
      <img class="avater" :src="userData.avatar"/>
      <span>{{userData.username}} </span>
      <p>开通会员 <i class="el-icon-arrow-right"></i></p>
    </div>
    <div v-if="total > 0" class="vipMember">
      <img class="avater" :src="userData.avatar" />
      <span>{{userData.username}} </span>
      <p>{{arr.endtime}} 到期</p>
      <img class="vipimg" src="~assets/images/vipimg.png" />
    </div>
    <div class="head">
      <div style="height:75px"></div>
      <p>累计收益<font style="padding-left:10px;position:absolute" @click="$router.push('mwallet')">提现<i class="el-icon-arrow-right"></i></font></p>
      <h2>{{price}}<font>元</font></h2>
      <p>近期收入{{near}}元</p>
    </div>
    <div class="draw">
      <p class="tst">咖啡收益二选一（每天只能领取一次）</p>
      <ul>
        <li v-for="(item,i) in device">
          <div class="title">
            {{item.name}}/{{item.size == 1 ? '中杯' : '小杯'}}<span>({{i == 0 ? '返现' : '景点入园票'}})</span>
            <font>{{item.createtime}}</font>
          </div>
          <p v-if="i==0 && item.status == null" @click="draw">
          <span v-if="total > 0">您已是平台VIP会员，返现金额为{{arr.rebate}}元</span>
          <span v-if="total <= 0">请先开通为平台VIP会员时，即可领取返现金额</span>
          <font v-if="item.status == null">领取<i class="el-icon-arrow-right"></i></font>
          </p>

          <p v-if="i==0 && item.status != null">开通为平台VIP会员时，即可返现{{arr.rebate}}元<font v-if="item.status == 1">已领取返现</font></p>

          <p v-if="i==1 && item.status == null" @click="drawScenic">普通会员、平台VIP会员，即可领取门票一张<font v-if="item.status == null">领取<i class="el-icon-arrow-right"></i></font></p>

          <p v-if="i==1 && item.status != null">普通会员、平台VIP会员，即可领取门票一张<font v-if="item.status == 2">已领取门票</font></p>
        </li>
      </ul>
    </div>

    <div class="runing">
      <ul>
        <li v-for="(item,i) in finance">{{item.createtime}}
          <font v-if="item.status == 1">￥{{item.price}}</font>
          <font v-if="item.status == 2">景区门票</font>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        total:0,
        arr:[],
        device:[],
        finance:[],
        price:0.00,
        near:0.00,
        positionFlag:false,
        code:'',
        id:''
      };
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('user') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          var url = encodeURIComponent('http://user.4008005216.com/main/menber?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }
    },
    beforeMount() {
      this.baseUrl = this.$host;
      this.id = this.$route.query.id
    },
    mounted() {
      this.beforeMount();
      this.getDetail()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      draw:function(){
        var that = this;
        var id = this.$route.query.id;
        if(that.total <= 0){
          that.$alert('请先开通VIP会员才能领取返现哦！', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/draw',
          params:{
            id:id,
            user_id:that.userData.id,
            rebate:that.arr.rebate
          }
        }).then(function(response){
          var res = response.data;
          if(res.status == 200){
            that.$alert(res.message, '提示', {
              confirmButtonText: '确定'
            });
            that.getDetail();
          }else{
            that.$alert(res.message, '提示', {
              confirmButtonText: '确定'
            });
          }
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      drawScenic:function(){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/scenicDraw',
          params:{
            id:id,
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data;
          if(res.status == 200){
            that.toPush(id,'mpark');
          }else{
            that.$alert(res.message, '提示', {
              confirmButtonText: '确定'
            });
          }
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      getDetail:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/isUser',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data;
          that.total = res.data.total;
          that.arr = res.data.rs == null ? [] : res.data.rs;
          that.getDevice()
          that.getRinance();
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      getDevice:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/deviceOrder',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data;
          that.device = res.data;
          console.log(res.data)
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      getRinance:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/finance',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data;
          that.finance = res.data.rs;
          that.price = res.data.price;
          that.near = res.data.near;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('user', JSON.stringify(res.data));
          that.userData = res.data;
          that.getscenic();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:80%;
  }
  .menberApp{
    background:#ececec;
  }
  .menberApp .head{
    width:100%;
    background:#E6B840;
    height:200px
  }
  .menberApp .head p{
    color:#f7f7f7;
    text-align:center;
    font-size:14px
  }
  .menberApp .head h2{
    color:#fff;
    text-align:center;
    font-size:28px;
    padding:12px 0;
    letter-spacing:1px
  }
  .menberApp .head h2 font{
    font-size:14px
  }
  .menberApp .vipMember{
    height:40px;
    position:fixed;
    width:100%;
    background:rgba(255,255,255,0.5)
  }
  .menberApp .vipMember .avater{
    width:25px;
    height:25px;
    border-radius:50%;
    float:left;
    margin:8px 0 0 4%
  }
  .menberApp .vipimg{
    position:absolute;
    top:6px;
    left:8%;
    width:15px
  }
  .menberApp .vipMember span{
    float:left;
    height:40px;
    line-height:40px;
    font-weight:500;
    font-size:15px;
    color:#000;
    margin-left:10px
  }
  .menberApp .vipMember p{
    font-size:15px;
    padding-left:10px;
    float:right;
    margin-right:4%;
    height:40px;
    line-height:40px;
    color:#666
  }
  .menberApp .draw .tst{
    text-align:center;
    font-size:14px;
    color:#696969;
    height:50px;
    line-height:50px;
  }
  .menberApp .draw ul{
    width:92%;
    margin:0 auto 25px auto;
  }
  .menberApp .draw ul li{
    background:#fff;
    border-radius:5px;
    height:85px;
    margin-bottom:10px;
  }
  .menberApp .draw ul li .title{
    width:92%;
    margin:0 auto;
    font-size:15px;
    font-weight:500;
    padding-top:15px;
  }
  .menberApp .draw ul li .title span{
    font-size:13px;
    color:#E6B840;
    padding-left:8px;
    position:relative;
    top:-2px
  }
  .menberApp .draw ul li .title font{
    float:right;
    color:#666
  }
  .menberApp .draw ul li p{
    width:92%;
    margin:0 auto;
    font-size:13px;
    color:#666;
    padding-top:13px
  }
  .menberApp .draw ul li p font{
    color:#f00;
    float:right;
  }
  .menberApp .runing ul{
    background:#fff;
  }
  .menberApp .runing li{
    height:60px;
    line-height:60px;
    width:92%;
    margin: 0 auto;
    border-bottom:solid 1px #f1f1f1;
    color:#666
  }
  .menberApp .runing li:last-child{
    border-bottom:none;
  }
  .menberApp .runing li font{
    float:right;
    color:#000
  }

  .menberApp .vip{
    diplay:block;
    width:100%;
    margin:0 atuo
  }
  .menberApp .kai{
    display:block;
    width:140px;
    height:45px;
    line-height:45px;
    background:#FD8320;
    color:#fff;
    font-size:16px;
    font-weight:500;
    text-align:center;
    border-radius:45px;
    margin:0 auto
  }
  .menberApp .meheader{
    background: linear-gradient(90deg, #61BEFF, #4F7CFF);
    position:relative;
  }
  .menberApp .headMe{
    width:92%;
    margin:0 auto;
    padding:20px 0;
  }
  .menberApp .headMe a{
    position:absolute;
    right:0px;
    top:20px;
    color:#fff;
    background:#f00;
    border-radius: 30px 0 0 30px;
    width: 80px;
    height: 30px;
    text-align:center;
    line-height:30px;
    font-weight: 600;
    font-size:14px;
  }
  .menberApp .headMe:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .menberApp .headMe img{
    width:60px;
    border-radius:100%;
    float:left;
  }
  .menberApp .headMe .right{
    float:left;
    width:75%;
    margin-left:3%;
  }
  .menberApp .headMe .right h2{
    font-size:17px;
    color:#fff;
    padding-top:4px
  }
  .menberApp .headMe .right p{
    font-size:14px;
    color:#fff;
    padding-top:5px
  }
  .menberApp .tq{
    width:100%;
    margin:0 auto 15px auto;
    background:#fff;
    padding-bottom:20px;
  }
  .menberApp .tq h2{
    font-size:16px;
    width:92%;
    padding:20px 0;
    margin:0 auto
  }
  .menberApp .tq ul{
    width:100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin: 0;
  }
  .menberApp .tq ul li{
    width:30%
  }
  .menberApp .tq ul li img{
    display:block;
    width:70px;
    margin:0 auto;
  }
  .menberApp .tq ul li p{
    text-align:center;
    font-size:15px;
    color:#666;
    padding-top:5px
  }
  .menberApp .card h2{
    font-size:16px;
    width:92%;
    padding:5px 0 15px 0;
    margin:0 auto
  }
  .menberApp .card ul{
    width:100%;
    display:block;
    margin:0 auto;
  }
  .menberApp .card ul li{
    background:#fff;
    width:100%;
    margin-bottom:15px;
    position:relative;
  }
  .menberApp .card ul li h3{
    font-size:15px;
    padding:15px 15px 10px 15px;
    width:75%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1px;
    color:#333
  }

  .menberApp .card ul li .price{
    font-size:15px;
    padding:0 15px 10px 15px;
    color:#999
  }
  .menberApp .card ul li .rate{
    font-size:15px;
    padding:0 15px 10px 15px;
    color:#999
  }
  .menberApp .card ul li .price font{
    color:#999;
    font-size:15px;
  }
  .menberApp .card ul li .price b{
    color: #f00;
    font-size:17px;
  }

  .menberApp .card ul li .price i{
    color: #f00;
    font-size:12px;
    font-style:normal
  }

  .menberApp .card ul li a{
    position:absolute;
    right:20px;
    top:70%;
    transform: translateY(-50%);
    color:#fff;
    background:#f00;
    border-radius: 30px;
    width: 90px;
    height: 30px;
    text-align:center;
    line-height:30px;
    font-weight: 600;
    font-size:14px;
  }
</style>